import { queryOptions, useQuery, UseQueryOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { Invoice, Pagination } from '@/types'

type ListInvoicesParams = {
  deal_key: string
  page?: number
  page_size?: number
  status?: string
  due_date?: string
}

export const listInvoices = async ({
  deal_key,
  ...params
}: ListInvoicesParams) => {
  const response = await httpClient('accounting-dealer').get<
    Pagination<Invoice>
  >(`/v3/invoice/${deal_key}/list`, { params })

  return response.data
}

export const listInvoicesOptions = (
  params: ListInvoicesParams,
  options?: UseQueryOptions<Pagination<Invoice>>,
) =>
  queryOptions({
    queryKey: ['invoices', params],
    queryFn: () => listInvoices(params),
    ...options,
  })

export const useListInvoices = (
  params: ListInvoicesParams,
  options?: UseQueryOptions<Pagination<Invoice>>,
) => {
  return useQuery(listInvoicesOptions(params, options))
}
